import { computed } from 'easy-peasy'
import isDev from '../../utils/isDev'

export default {
  locale: null,
  items: {},
  t: computed(state => (id, { optional }) =>
    id.split('.').reduce((node, child, i, arr) => {
      if (node[child]) return node[child]
      arr.splice(1) // break
      if (!optional && isDev)
        // console.log(
        //   `%cTranslation error: ${id} not found`,
        //   'color: red',
        // )
        return null
    }, state.items),
  ),
}
